module.exports = __webpack_public_path__ + "static/digiprotec-9d11063be888bd9e3a6839f3be1515f6.jpg";